import EventsTimelineView from "./EventsTimelineView";
import StatsTimelineView from "./StatsTimelineView";
import state from "../state";

class TimelineContainerView {
  constructor() {
    this.eventsTimelineView = new EventsTimelineView();
    this.statsTimelineView = new StatsTimelineView();

    this.eventsTimelineView.syncRangeChange(this.statsTimelineView, this.adjustLabelWidth);
    this.statsTimelineView.syncRangeChange(this.eventsTimelineView, this.adjustLabelWidth);
  }

  adjustLabelWidth(eventsTimeline, statsTimeline) {
    const groupLeftWidth = eventsTimeline.dom.leftContainer.clientWidth;
    statsTimeline.dom.leftContainer.style.width = groupLeftWidth;
  }
}

export default TimelineContainerView;
